export default __webpack_public_path__ + "static/media/15.e6c66867.jpg";